<template>
  <div class="home data-panel-home">
    <Layout type="HOME" :pageTitle="$t('pageTitle')" titleSrc="/menu/homeIcon_black.png">
      <BasiceLayout :title="$t('littleTitle')">
        <!-- 架构选择 -->
        <span class="netcon-device-type">{{ $t('deviceType') }}:</span>
        <el-select v-model="arch" v-if="networkContribution !== 'NODATA'" @change="changeDeviceType">
          <el-option label="ARM" value="arm"></el-option>
          <el-option label="X86" value="amd"></el-option>
        </el-select>
        <el-table v-if="networkContribution !== 'NODATA'" class="network-table" :data="networkContribution"
          empty-text="Loading..." style="width: 100%">
          <el-table-column :label="$t('ranking')" align="center">
            <template slot-scope="scope">
              <div class="cup-wrap"><i v-if="scope.$index === 0 || scope.$index === 1 || scope.$index === 2"
                  class="el-icon-trophy-1 cup" style="color:#ffc800"></i>{{scope.$index + 1}}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('email')" align="center">
            <template slot-scope="scope">
              <div>{{scope.row.email}}</div>
            </template>
          </el-table-column>
          <!-- mac -->
          <el-table-column prop="mac_address" :label="$t('macAddress')" align='center'>
          </el-table-column>
          <!-- 贡献 -->
          <el-table-column prop="contribution" :label="$t('contribution')" align='center'>
          </el-table-column>
          <!-- 运营商 -->
          <el-table-column prop="" :label="$t('operators')" align='center'>
             <template slot-scope="scope">
              <div v-if="scope.row.operator ==='ct'">{{$t('ct')}}</div>
              <div v-else-if="scope.row.operator ==='cu'">{{$t('cu')}}</div>
              <div v-else-if="scope.row.operator ==='cm'">{{$t('cm')}}</div>
              <div v-else>{{$t('unknown')}}</div>
            </template>
          </el-table-column>
          <!-- BP收益 -->
          <el-table-column :label="$t('revenue')" align='center'>
            <template slot-scope="scope">
              <div>{{scope.row.mc_weight}} BP</div>
            </template>
          </el-table-column>
          <!-- 现金收益 -->
          <el-table-column :label="$t('revenue')" align='center' :render-header="renderHeader">
            <template slot-scope="scope">
              <div v-if="isZnWebsite">￥ {{scope.row.bxc_value.toFixed(6)}}</div>
              <div v-if="!isZnWebsite">$ {{scope.row.bxc_value_usdt.toFixed(6)}}</div>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="networkContribution === 'NODATA'" class="no-data">
          <div v-if="isZnWebsite">暂无数据</div>
          <div v-if="!isZnWebsite">No Data</div>
        </div>
      </BasiceLayout>
    </Layout>
  </div>
</template>

<script>
  // @ is an alias to /src
  import Header from "@/components/Header.vue";
  import { mapState, mapActions, mapMutations } from "vuex";
  import Layout from "@/components/DatePanel/Layout.vue";
  import BasiceLayout from "@/components/Common/BasicLayout.vue";
  import moment from "moment";
  import { getCookie } from "@/utils/utils";

  export default {
    name: "home",
    components: {
      Layout,
      BasiceLayout
    },
    data() {
      return {
        // language: getCookie("NEW_BASIC_LANUAGE"),
        arch: 'arm',
        date_at: moment()
        .utc()
        .startOf("day")
        .subtract(1, "days")
        .valueOf()
      };
    },
    computed: mapState({
      isZnWebsite: state => state.isZnWebsite,
      networkContribution: state => state.networkContribution
    }),
    created() {
      console.log(this.data_at)
      this.getNetworkContribution({ date_at: this.date_at, arch: this.arch });
    },
    methods: {
      ...mapActions(["getNetworkContribution"]),
       renderHeader: function(creatElement, { column, $index }) {
        let fields = this.fields;
        return creatElement("div", [
          column.label,
          creatElement(
            "el-tooltip",
            {
              class: "cell-s-tip",
              props: {
                content: (function() {
                  let label = column.label;
                  switch (label) {
                    case "收益":
                      return "根据交易所7日均价计算。";
                      break;
                    case "Revenue":
                      return "Calculated according to the exchange's 7-day average price.";
                      break;
                  }
                })(),
                effect: "dark",
                placement: "top"
              }
            },
            [
              creatElement("i", {
                class: "fa fa-question-circle revenue-icon el-icon-question"
              })
            ]
          )
        ]);
      },
      changeDeviceType(value) {
        this.getNetworkContribution({ date_at: this.date_at, arch: value });
      }
    },
  };
</script>

<style scoped lang="stylus">
  .netcon-device-type{
    margin: 40px 40px;
  }

  .data-panel-home.home {
    height: auto !important;
  }

  .cup {
    display: inline-block;
    margin-right: 15px;
  }

  .no-data {
    padding: 20px;
  }

  .cup-wrap {
    width: 80px;
    display: inline-block;
    text-align: center;
    position: relative;
    height: 23px;
    line-height: 23px;
  }

  .cup {
    position: absolute;
    top: 5px;
    left: 5px;
  }
</style>

<i18n>
  {
  "en": {
    "pageTitle": "Network Contribution",
    "littleTitle": "Computing Task TOP100",
    "email": "Account",
    "macAddress": "Mac Address",
    "revenue": "Revenue",
    "ranking": "Ranking",
    "contribution": "Contribution",
    "deviceType": "Device Type"
  },
  "zn": {
    "pageTitle": "全网贡献",
    "littleTitle": "计算任务昨日贡献TOP100",
    "email": "帐号",
    "macAddress": "设备",
    "revenue": "收益",
    "ranking": "排名",
    "contribution": "贡献值",
    "deviceType": "设备类型"
  }
}
</i18n>
